import cx from "classnames"
import PropTypes from "prop-types"
import React from "react"
import { usePageAssets } from "hooks/usePageAssets"
import Container from "components/ui/Container"
import Image from "components/ui/Image"

function DecoratedSection({ className, children, reversed }) {
  const { getAsset } = usePageAssets()
  const illustration = getAsset("abstract-waves-svg")
  return (
    <Container className={cx(className, "relative")} section>
      {children}
      <div
        className={cx(
          "absolute top-1/2 -z-10 hidden max-w-[65%] lg:block lg:-translate-y-1/4 2xl:-translate-y-[30%]",
          reversed ? "left-0 xl:-left-10" : "right-0 xl:-right-10"
        )}
      >
        <Image src={illustration} />
      </div>
    </Container>
  )
}

DecoratedSection.propTypes = {
  /** Additional className(s) */
  className: PropTypes.string,
  /** Section content */
  children: PropTypes.node,
  /** If true, position decoration on the left side */
  reversed: PropTypes.bool,
}

export default DecoratedSection
